import { ChangeDetectionStrategy, ChangeDetectorRef, Component, LOCALE_ID, Inject } from '@angular/core';
import { customFieldsBase } from '../custom-fields-base';

@Component({
    selector: 'app-custom-fields-input-type',
    templateUrl: './custom-fields-input-type.component.html',
    styleUrls: ['./custom-fields-input-type.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomFieldsInputTypeComponent extends customFieldsBase {
    constructor(cdr: ChangeDetectorRef, @Inject(LOCALE_ID) localeId: string) {
        super(cdr, localeId);
    }
}
